module.exports = __webpack_public_path__ + "img/1486704891.c6ce0980.jpg";